// removed by extract-text-webpack-plugin
module.exports = {"Container":"settings__Container__1MHMS","Fullscreen":"settings__Fullscreen__251Ic","SettingsContainer":"settings__SettingsContainer__3RSue settings__Fullscreen__251Ic","Settings":"settings__Settings__jqQ9V","Setting":"settings__Setting__1LjGt","SpeedSetting":"settings__SpeedSetting__2BlcP settings__Setting__1LjGt","Inactive":"settings__Inactive__3XaPO","Active":"settings__Active__2iO85 settings__Inactive__3XaPO","Back":"settings__Back__ErDaP"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Replayer/settings.css
// module id = 1724
// module chunks = 2